import { render } from "./ai-form-text-box-dictionary.vue?vue&type=template&id=a5266b16"
import script from "./ai-form-text-box-dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-text-box-dictionary.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-text-box-dictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5266b16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5266b16', __exports__)) {
    api.reload('a5266b16', __exports__)
  }
  
  module.hot.accept("./ai-form-text-box-dictionary.vue?vue&type=template&id=a5266b16", () => {
    api.rerender('a5266b16', render)
  })

}


export default __exports__